import {
    FETCH_ALL_SUBSCRIPTION_SUCCESS, EDIT_SUBSCRIPTION, UPDATE_SUBSCRIPTION_SUCCESS, CREATE_SUBSCRIPTION_SUCCESS, DELETE_SUBSCRIPTION_SUCCESS,SET_SUBSCRIPTION,SET_ROLE
} from "constants/subscriptions.constants";

const INIT_STATE = {
    subscriptions: [],
    subscription_roles:[],
    subscription: {
        id: 0,
        name: '',
        initial_cost: 0.0,
        initial_duration: 0,
        cost_after_initial: 0.0,
        repeat_duration:0,
        is_never_end:false,
        end_date:'',
        start_date:'',
    }
};
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case SET_ROLE: {
            let c = Object.assign({}, state.subscription);
            let s = Boolean(action.value)

            var str = "";
            if (c.role_ids !== undefined) {
                str = c.role_ids;
            }

            if (s) {
                if (str === "") {
                    str = "" + action.key;
                } else {
                    str = str + "," + action.key;
                }
            } else {
                str = c.role_ids.replace(new RegExp(action.key + ',?'), '');
            }
            c.role_ids = str
            return {
                ...state,
                subscription:c
            }
        }
        //set subscription
        case SET_SUBSCRIPTION: {
            let c = Object.assign({}, state.subscription);
            c[action.key] = action.value
            return {
                ...state,
                subscription: c
            }
        }
        case FETCH_ALL_SUBSCRIPTION_SUCCESS: {
            return {
                ...state,
                subscriptions: action.payload.data,
                pagination: action.payload.page
            }
        }

        case UPDATE_SUBSCRIPTION_SUCCESS: {
            let foundIndex = state.subscriptions.findIndex(x => x.id === action.payload.data.id);
            let all = Object.assign([], state.subscriptions);
            let o =  action.payload.data
            all[foundIndex] = o
            return {
                ...state,
                subscriptions: all,
                subscription: o,
            }
        }

        case CREATE_SUBSCRIPTION_SUCCESS: {
            let all = Object.assign([], state.subscriptions);
            all.push(action.payload.data)
            return {
                ...state,
                subscriptions: all,
                subscription: INIT_STATE.subscription
            }
        }

        case DELETE_SUBSCRIPTION_SUCCESS: {
            let all = Object.assign([], state.subscriptions);
            let newArray = all.filter(function (c) {
                return c.id !== action.payload.id
            });
            return {
                ...state,
                subscriptions: newArray,
            }
        }

        case EDIT_SUBSCRIPTION: {
            let u = state.subscriptions.find(c => c.id === action.payload)
            let o = Object.assign({}, u)
        
           // o.country_id = o.country.id
           // o.subscription_type_id = o.partner_type.id
            return {
                ...state,
                subscription: o
            }
        }

        

        
        default:
            return state;
    }
}